export enum ReferenceEntryType {
	Workspace = 'workspace',
	Corner = 'corner',
	CustomAppliance = 'custom_appliance',
	CustomPanel = 'custom_panel',
	CustomPanelPage = 'custom_panel_page',
	Cutout = 'cutout',
	CenterMarker = 'center_marker',
	NoOp = 'no_op',
}
